export const BATCH_GROUP = 'batch_group';
export const FREE = 'free';
export const BATCH = 'batch';
export const BATCH_GROUPS = 'batch_groups';
export const TOPICS = 'topics';
export const DPPS = 'educator_dpp';

// Events Constants
export const BANNER_CLICKED = 'Banner - Banner Clicked';
export const TOPICS_TAB_CLICKED = 'Educator - Profile Tab Clicked';
export const EDUCATOR_PROFILE_VIEWED = 'Educator Profile Viewed';
export const PRACTICE_STARTED = 'Practice - Practice Started';

export const stripLength = {
  goal: 11,
  topic: 13
};

export const MIN_QUIZ_ATTEMPTS = 10;

export const PARTNER_EDUCATOR_CONFIG = {
  color: {
    primary: '#6496BC'
  },
  asset: {
    badge: 'https://static.uacdn.net/web-cms/Partner_badge_2_4a9f6a1b22.png'
  },
  name: 'Partner Educator'
};
